import React, { useState, useEffect } from 'react';
import '../css/style.css'; // Previously: './OurOffer.css';

const OurOffer = () => {
    const [loading, setLoading] = useState(true);
    const [offerDetails, setOfferDetails] = useState(null);

    useEffect(() => {
        const fetchOfferDetails = async () => {
            try {
                // Simulacija API poziva za dinamičke podatke o ponudi
                setOfferDetails("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.");
                setLoading(false);
            } catch (err) {
                console.error("Error fetching offer details", err);
                setLoading(false);
            }
        };

        fetchOfferDetails();
    }, []);

    if (loading) {
        return <p>Loading our offer...</p>;
    }

    return (
        <div className="offer-page">
            {/* Header sa slikom */}
            <div
                className="header-image"
                style={{
                    backgroundImage: `url(/images/default.jpg)`, // Putanja do slike
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: '300px',
                    width: '100vw',
                }}
            >
                <div className="page-title-container">
                    <h1 className="page-title">Our Offer</h1>
                </div>
            </div>

            {/* Centralni sadržaj */}
            <div className="offer-details">
                <h2>What We Offer</h2>
                <p>{offerDetails}</p>
                <p>We provide a variety of services including...</p>
                {/* Ovdje možete dodati više informacija o ponudi */}
            </div>
        </div>
    );
};

export default OurOffer;
